import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {DigestTypeEnum} from 'nutshell-graphql-types';
import type {
    GetDigestPreview as GetDigestPreviewQuery,
    GetDigestPreviewVariables as GetDigestPreviewQueryVariables,
} from 'nutshell-graphql-types';

import GET_DIGEST_PREVIEW from '../queries/get-digest-preview.graphql';

export const useGetDigestPreview = (digestType: DigestTypeEnum) => {
    const {loading, data, error, refetch} = useQuery<
        GetDigestPreviewQuery,
        GetDigestPreviewQueryVariables
    >(GET_DIGEST_PREVIEW, {
        variables: {digestType},
        fetchPolicy: 'cache-first',
    });

    const preview = data ? data.digestPreview : null;

    return {
        isLoading: loading && !preview,
        preview,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
